import React from 'react';
import { useForm } from 'react-hook-form';
import { ChatContainerBaseConfig } from '../../../base';
import { ThreadContextContainerProps } from './contextSelectProps';
import { ThreadContextController } from './contextSelectInterface';
import { ThreadContextFormValues } from './contextSelectModel';
import { ThreadContextItem } from '@varos/assistant-sdk';

export function createThreadContextContainer(
    config: ChatContainerBaseConfig,
    controller: ThreadContextController
): React.FC<ThreadContextContainerProps> {
    const {
        context: { useContext },
        state: states,
    } = config;

    return states.composer.subscribe(
        ({ as: View, ...containerProps }: ThreadContextContainerProps) => {
            const context = useContext();

            // Navigation state for nested context selection
            const [currentScreen, setCurrentScreen] = React.useState<'main' | string>(
                'main'
            );

            const props = controller.useProps(context, {
                selected: containerProps.value,
                navigation: {
                    currentScreen,
                    setCurrentScreen,
                },
                onRemoveContext(id) {
                    // Extract index from the id (format: "kind_index")
                    const index = parseInt(id.split('_')[1], 10);
                    if (!isNaN(index)) {
                        const newItems = containerProps.value.filter(
                            (_, i) => i !== index
                        );
                        containerProps.onChange(newItems);
                    }
                },
                onSolution(item) {
                    console.log('onSolution', item);
                    containerProps.onChange([
                        ...containerProps.value,
                        {
                            kind: 'solution',
                            solutionId: item.id,
                        },
                    ]);
                },
                onCollection(item) {
                    containerProps.onChange([
                        ...containerProps.value,
                        {
                            kind: 'collection',
                            collectionId: item.id,
                        },
                    ]);
                },
                onClose() {
                    containerProps.onClose?.();
                },
            });
            return <View {...props} />;
        }
    );
}
